// extracted by mini-css-extract-plugin
module.exports = {"bms_sidebar":"GlobalLeftPanel_bms_sidebar__1X_d9","bms_button":"GlobalLeftPanel_bms_button__4_Ean","bms_sidebar_button":"GlobalLeftPanel_bms_sidebar_button__Pl29d"};